import React from 'react';
import { TableBody, TableCell, TableContainer, TableHead, TableRow, Table, IconButton, useMediaQuery } from '@mui/material';
import { IconCaretRightFilled } from '@tabler/icons-react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { StringKeys } from '../../../../resources/strings/StringKeys';
import CustomPagination from '../../../../components/pagination/CustomPagination';

const DepartmentsTable = ({ departments, page, rowsPerPage, handleChangePage, handleChangeRowsPerPage }) => {
  const navigate = useNavigate();
  const isMobile = useMediaQuery('(max-width:600px)');
  const { t } = useTranslation();

  const handleRowClick = (department) => {
    navigate(`/departments/${department.id}`);
  };

  return (
    <>
      <TableContainer style={{ overflowX: 'auto' }}>
        <Table>
          <TableHead className="users-table-header">
            <TableRow>
              <TableCell style={{ fontWeight: 'bold' }}>{t(StringKeys.DEPARTMENT)}</TableCell>
              {isMobile && <TableCell style={{ fontWeight: 'bold' }}></TableCell>}
            </TableRow>
          </TableHead>
          <TableBody>
            {departments.map((department) => (
              <TableRow
                style={{ cursor: isMobile ? 'default' : 'pointer' }} // Disable cursor pointer in mobile
                onClick={() => !isMobile && handleRowClick(department)} // Click only on non-mobile
                key={department.id}
              >
                <TableCell>{department.name}</TableCell>
                {isMobile && (
                  <TableCell sx={{ textAlign: "end" }}>
                    <IconButton onClick={(e) => { e.stopPropagation(); handleRowClick(department); }}>
                      <IconCaretRightFilled />
                    </IconButton>
                  </TableCell>
                )}
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      <CustomPagination
        rowsPerPageOptions={[10, 25, 100, { label: 'All', value: -1 }]}
        component="div"
        count={departments.length}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />
    </>
  );
};

export default DepartmentsTable;
